/* eslint-disable */
import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { useLocation, useHistory } from 'react-router-dom'
import { DatePicker } from 'antd'

import { addToQuerystring } from '../../../../utils/querystring'

const { RangePicker } = DatePicker

const DateFilter = ({ startDate, endDate, event }) => {
    const location = useLocation()
    const history = useHistory()

    const startDateAsMoment = startDate && moment(startDate)
    const endDateAsMoment = endDate && moment(endDate)

    const startDateAsMomentString =
        startDateAsMoment == null ? null : startDateAsMoment.format()

    const endDateAsMomentString =
        startDateAsMoment == null ? null : startDateAsMoment.format()

    const [start, setStart] = useState(startDateAsMoment)
    const [end, setEnd] = useState(endDateAsMoment)

    useEffect(() => {
        setStart(startDateAsMoment)
        setEnd(endDateAsMoment)
    }, [startDateAsMomentString, endDateAsMomentString])

    const updateRoute = (startDate = null, endDate = null) => {
        const newLocation = addToQuerystring(location, {
            startDate: startDate && moment(startDate).format('YYYYMMDDTHHmm'),
            endDate: endDate && moment(endDate).format('YYYYMMDDTHHmm'),
        })

        history.push(newLocation)
    }

    const onOk = ([startDateMoment = null, endDateMoment = null]) => {
        updateRoute(startDateMoment, endDateMoment)
    }

    const onChange = ([startDateMoment = null, endDateMoment = null]) => {
        const clickedClear = startDateMoment == null && endDateMoment == null

        if (clickedClear) {
            updateRoute()
        } else {
            setStart(startDateMoment)
            setEnd(endDateMoment)
        }
    }

    return (
        <div>
            <RangePicker
                value={[start, end]}
                showTime={{
                    format: 'HH:mm',
                    defaultValue: [
                        moment('00:00', 'HH:mm'),
                        moment('23:45', 'HH:mm'),
                    ],
                    minuteStep: 15,
                }}
                defaultPickerValue={[
                    moment(event.eventStartDate),
                    moment(event.eventEndDate),
                ]}
                format="DD MMM YYYY HH:mm"
                onOk={onOk}
                onChange={onChange}
            />
        </div>
    )
}

export default DateFilter
